/*
 * @Date: 2023-11-13 15:40:30
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-13 17:53:58
 * @FilePath: /ckb-mall-web/src/hooks/useCartLength.ts
 * @Description:
 * @Author: lihwang
 */
import { useAtom } from 'jotai';
import { useRequest } from 'ahooks';
import { CartLength } from '@/model';
import { request } from '@/config/request';
import { isLogin } from '@/config/request/login';
import { useEvent } from '.';

export const useCartLength = () => {
    const { runAsync: apiGetCartList } = useRequest(request.order.cart.list, {
        manual: true
    });
    const [, setCartLength] = useAtom(CartLength.cartLength);
    const setNewCartLengthWithRequest = useEvent(async () => {
        if (isLogin()) {
            const cartList = await apiGetCartList();
            setCartLength(cartList.data?.length || 0);
        }
    });
    return { setNewCartLengthWithRequest, setCartLength };
};
export default useCartLength;
